var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('header',[_c('h3',[_vm._v(_vm._s(_vm.name))])]),(_vm.fetchingData)?_c('span',[_vm._v("Cargando...")]):_vm._e(),(!_vm.fetchingData)?_c('task-list',{key:'list-'+_vm.listId,attrs:{"listId":_vm.listId,"tasks":_vm.tasksList}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }